
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-user",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.296 17.249a8.625 8.625 0 110-17.25 8.625 8.625 0 010 17.25zM31.995 32c-.035-.298-32.018 0-31.99-.298C.928 21.751 6.162 19.166 16 19.166c9.935 0 14.81 2.636 15.995 12.834z"}})])
          )
        }
      }
    